export enum PaddingCubeSide {
  bottom = "bottom",
  top = "top",
}
